/**
 * @Author: v_jppjpeng
 * @Date: 2022-10-08 10:14:38
 * @Explain: 后台接口 - 错误码
 */

import {
  ACCOUNT_CENTER_API_KEY_MAX_NUM,
  PREFERENCE_MANAGE_OPTION_MAX_NUM,
} from '@/config/defaultConfig';

export default {
  // 请求失败
  'API.ERROR.REQ.WAS.ABORTED':
    '[{url}-{reqId}]Request failed, error type [{code}], error message [{message}]. Please contact the developer for assistance.',
  'API.ERROR.CODE.UNKNOWN': 'Unknown error',
  'API.ERROR.CODE.10114': 'Content contains sensitive information',
  // HTTP 状态码
  'API.ERROR.CODE.400': 'Request syntax error',
  'API.ERROR.CODE.401': 'Login failed, please try again',
  'API.ERROR.CODE.403': 'Request cannot be executed',
  'API.ERROR.CODE.404': 'Interface request failed',
  'API.ERROR.CODE.405': 'Request method incorrect',
  'API.ERROR.CODE.500':
    'Server is experiencing problems, please try again later.',
  'API.ERROR.CODE.502': 'Service is busy, please try again later',
  'API.ERROR.CODE.504': 'Request timed out, please try again later',

  'API.ERROR.CODE.1001': 'No permission for this operation!',
  'API.ERROR.CODE.1003': 'Signature invalidation',

  'API.ERROR.CODE.2000': 'Campaign name entered already exists',
  'API.ERROR.CODE.2001': 'Approval failed',
  'API.ERROR.CODE.2002': 'No default language set',
  'API.ERROR.CODE.2003':
    "Campaign approval succeeded, but failed to obtain the applicant's email configuration. Please check the email configuration.",
  'API.ERROR.CODE.2004': 'Campaign approval succeeded, email sending failed',
  'API.ERROR.CODE.2008': 'The time between two reminders should be 30 minutes',
  'API.ERROR.CODE.2013': 'The start time cannot be modified',
  'API.ERROR.CODE.2014':
    'Specified start and end dates do not contain the set {day} number',
  'API.ERROR.CODE.2015':
    'The specified start and end dates do not contain the set {day}',
  'API.ERROR.CODE.2016': 'The campaign has started, revocation failed',

  'API.ERROR.CODE.3000': 'No permission for this operation',
  'API.ERROR.CODE.30011':
    'Failed to copy email template, please try again later',
  'API.ERROR.CODE.3001':
    "You're already part of the project. If your permissions need to be changed, please contact the project owner.",

  'API.ERROR.CODE.4001':
    'Layer cannot be deleted because it is used in a campaign',
  'API.ERROR.CODE.4002': 'Duplicate names',

  'API.ERROR.CODE.5001':
    'Tag cannot be deleted because it is used in a campaign',
  'API.ERROR.CODE.10360': 'Cannot use ",", "|" or ";"',

  'API.ERROR.CODE.6001': 'Created rule already exists',
  'API.ERROR.CODE.16001': 'No permission for this operation',

  // 用户属性
  'API.ERROR.CODE.10361': 'Conflict with system field name. Avoid creation',

  'API.ERROR.CODE.7001': 'Name is a duplicate',
  'API.ERROR.CODE.7002': 'Please contact the owner',

  // 我的项目
  'API.ERROR.CODE.8000':
    'You have already applied to join this project, you cannot apply again',

  // 域名
  'API.ERROR.CODE.10004': 'Please check sender information', // 发送测试邮件 - '域名不存在',

  'API.ERROR.CODE.10054':
    'Email address entered is incorrect, please try again',
  'API.ERROR.CODE.10057': 'The user does not exist',
  'API.ERROR.CODE.10081':
    'Applicant {name} did not receive the reminder email, please inform them',
  'API.ERROR.CODE.10108': 'Folder name cannot be a duplicate',
  'API.ERROR.CODE.10110': 'Name cannot be a duplicate',
  'API.ERROR.CODE.10151':
    'Invalid email address(es) detected in the file, please check and upload again',
  'API.ERROR.CODE.10166': 'Current status: non editable',
  'API.ERROR.CODE.10175': 'Uploaded file does not match required format',
  'API.ERROR.CODE.10177': 'No corresponding contact is found',
  'API.ERROR.CODE.10178': "Sender's address must be unique",
  'API.ERROR.CODE.10184':
    'Incorrect region format detected in the file, please check and upload again',
  'API.ERROR.CODE.10185':
    'Files containing duplicate email addresses cannot be uploaded',
  'API.ERROR.CODE.10191':
    'Empty email addresses detected in the file, please check and upload again',
  'API.ERROR.CODE.10192':
    'Incorrect language format detected in the file, please check and upload again',
  'API.ERROR.CODE.10199': 'The data is empty',

  'API.ERROR.CODE.10314': 'Invitated email already exists',
  'API.ERROR.CODE.10315':
    'The sending address does not exist, please re-select',
  'API.ERROR.CODE.10351': 'Business does not exist',
  'API.ERROR.CODE.10354': 'Cannot exceed 1,000 tags',
  'API.ERROR.CODE.10355': 'Tag name already exists',
  'API.ERROR.CODE.10356':
    'This tag is linked to an API for ongoing contact imports and cannot be deleted.',
  'API.ERROR.CODE.10357': 'Attribute is a duplicate',

  'API.ERROR.CODE.10500': "Format of testers' email is incorrect, please check",
  'API.ERROR.CODE.10501':
    'Format of variable in test email is incorrect, please check',
  'API.ERROR.CODE.10502':
    'Variable in test email contains empty values, please check',
  'API.ERROR.CODE.10503':
    'Variable in test email contains duplicate key values, please check',
  'API.ERROR.CODE.10504': 'Email already exists',
  'API.ERROR.CODE.10508': 'User has been invited',
  'API.ERROR.CODE.10509': 'Invitation has expired',
  'API.ERROR.CODE.10512': "You can't invite yourself",
  'API.ERROR.CODE.10513':
    'Variable is used in an active campaign and cannot be deleted',

  // 偏好
  'API.ERROR.CODE.10517': 'Option name is a duplicate',
  'API.ERROR.CODE.10516': `Limit reached (${PREFERENCE_MANAGE_OPTION_MAX_NUM}/${PREFERENCE_MANAGE_OPTION_MAX_NUM})`,

  'API.ERROR.CODE.10520': 'Invalid email domain name',
  'API.ERROR.CODE.10521': 'Placeholder name already exists',
  'API.ERROR.CODE.10524':
    'The service is parsing the file, please try again later',
  'API.ERROR.CODE.10525':
    'Enter a valid key name. You can use alphanumeric characters and underscores.',

  // api-key
  'API.ERROR.CODE.10601': 'Name already exists',
  'API.ERROR.CODE.10602': 'Up to 50 API keys',
  'API.ERROR.CODE.10603': 'Name has been capped',
  'API.ERROR.CODE.10604': 'Remarks have been capped',
  'API.ERROR.CODE.10605': 'key id exception ',
  'API.ERROR.CODE.10606': 'Key already exists ',
  'API.ERROR.CODE.10608': 'Key has been revoked',

  // cos文件失效了
  'API.ERROR.CODE.10705': 'The downloaded file is invalid',

  // webhook
  'API.ERROR.CODE.10307':
    'The URL exceeds 1000 characters. Delete it and try again',
  'API.ERROR.CODE.10800': 'Invalid link, please re-enter',
  'API.ERROR.CODE.10801': 'Send test failure',
  'API.ERROR.CODE.10806': 'URL already exists',

  // 自动化活动
  'API.ERROR.CODE.12001': 'Automation name already exists',
  'API.ERROR.CODE.12002':
    'The selected contact source is referenced. Please check and try again',

  'API.ERROR.CODE.13001': 'Insufficient regions available',

  'API.ERROR.CODE.20001': 'Another person applied for this role',
  'API.ERROR.CODE.20002': 'Already applied for this role',
  'API.ERROR.CODE.20003': 'Approver does not have permission to apply',
  'API.ERROR.CODE.20004': 'Role cannot be deleted',
  'API.ERROR.CODE.20005': 'Data does not exist',
  'API.ERROR.CODE.20006': 'Cannot delete roles of other users',
  'API.ERROR.CODE.20007': 'Failed to call Pnt interface',
  'API.ERROR.CODE.20008': 'Pnt has not and cannot be approved',
  'API.ERROR.CODE.20009': 'Project roles do not support application by code',
  'API.ERROR.CODE.20010': 'Game does not exist',
  'API.ERROR.CODE.20011': 'Failed to add new user',
  'API.ERROR.CODE.20012':
    'Number of applications from user for owner role exceeds limit',
  'API.ERROR.CODE.20013': 'Error in retrieving user emails',
  'API.ERROR.CODE.20014':
    'Users who are not on the allowlist cannot log in and use the system',
  'API.ERROR.CODE.20015': 'No permission for this operation',
  'API.ERROR.CODE.20016': 'Demo service is not operating',
  'API.ERROR.CODE.20017': 'Pnt has been rejected and cannot be approved',
  'API.ERROR.CODE.20018': 'Reapplication is currently not supported',

  'API.ERROR.CODE.21003': 'Enter the registration form name',
  'API.ERROR.CODE.21004': 'Name is a duplicate',
  'API.ERROR.CODE.21011': 'Verification failed',
  'API.ERROR.CODE.21012': 'Digit code format is incorrect',
  'API.ERROR.CODE.21013': 'Digit code failed',
  'API.ERROR.CODE.21014': 'Digit code failed',
  'API.ERROR.CODE.21016': 'Backup code verification failed',
  'API.ERROR.CODE.21020': 'Template referenced, cannot be edit',
  'API.ERROR.CODE.21022':
    'The testing project does not allow the creation of campaigns with more than 249 contacts',
  'API.ERROR.CODE.21024': 'The default configuration is not set. Please check.',
  'API.ERROR.CODE.21025':
    'The default sender information has been deleted. Please check (your settings).',
  'API.ERROR.CODE.24002': 'Form does not exist',
  'API.ERROR.CODE.24003': 'Form has not been activated',

  // 登录、注册、忘记密码
  'API.ERROR.CODE.10002':
    'Sending verification code failed, please try again later',
  'API.ERROR.CODE.10003': 'Parameter error',
  'API.ERROR.CODE.10005':
    'Sending verification code failed, please try again later',
  'API.ERROR.CODE.10006': 'Domain Not Verified',
  'API.ERROR.CODE.10007': 'Domain Not Filled',
  'API.ERROR.CODE.10011': 'Verification code has expired',
  'API.ERROR.CODE.10012': 'Verification code error',
  'API.ERROR.CODE.10014':
    'Account or password incorrect, please check and try again',
  'API.ERROR.CODE.10015':
    'Account or password incorrect, please check and try again',
  'API.ERROR.CODE.10017': 'Email or user name is registered', // 邮箱地址已存在
  'API.ERROR.CODE.10018': 'Email or user name is registered', // 用户名已存在
  'API.ERROR.CODE.10023': 'Verification code has expired', // google验证码
  'API.ERROR.CODE.10028':
    'Your new password cannot be the same as your old password',

  // 模板、占位符被活动
  'API.ERROR.CODE.10115':
    'Actively being used in a campaign, cannot make any changes.',
  'API.ERROR.CODE.10528':
    'Actively being used in a campaign, cannot make any changes.',
  // 活动进行中禁止修改
  'API.ERROR.CODE.2010': 'The campaign is in progress and cannot be modified',
  'API.ERROR.CODE.10607': 'API key is being used in player journey',
  'API.ERROR.CODE.24001': 'Form is being used in player journey',
  'API.ERROR.CODE.15001':
    'Actively being used in a campaign, cannot make any changes.',

  // 被其它信息引用导致列表不可操作项补课操作提示文案
  'API.ERROR.CODE.00001': 'Currently used in a {who}, cannot be {doText}',
  'API.ERROR.CODE.00003': 'Campaign is ongoing, {name} cannot be modified.',
  'API.ERROR.CODE.00002': 'Currently used in a form, cannot be deleted',
  'API.ERROR.CODE.00004': 'Currently used in a form, cannot be renamed',
  'API.ERROR.CODE.00005': 'Currently used in a journey, cannot be modified',
  'API.ERROR.CODE.00006':
    'Template is currently being used, unable to make changes',
  'API.ERROR.CODE.00007': 'Currently in use, unable to make changes',

  // nest-WhatsApp接口报错文案
  'API.ERROR.CODE.NEST.401': 'Please login first',

  'API.ERROR.CODE.NEST.1000': 'Parameter error',
  'API.ERROR.CODE.NEST.1001': 'Phone number not found',
  'API.ERROR.CODE.NEST.1002': 'Data validation error',
  'API.ERROR.CODE.NEST.1003': 'Data does not exist',
  'API.ERROR.CODE.NEST.1004': 'Data already exists',
  'API.ERROR.CODE.NEST.1005': 'Permission denied',

  'API.ERROR.CODE.NEST.2000': 'File does not exist',
  'API.ERROR.CODE.NEST.2001': 'File read failed',
  'API.ERROR.CODE.NEST.2002': 'File parse failed',

  'API.ERROR.CODE.NEST.3000': 'Task does not exist',
  'API.ERROR.CODE.NEST.3001': 'Task status is invalid',
  'API.ERROR.CODE.NEST.3002': 'Task creation failed',
  'API.ERROR.CODE.NEST.3003': 'Task execution failed',

  'API.ERROR.CODE.NEST.4000': 'Rate limit exceeded',
  'API.ERROR.CODE.NEST.5000': 'Third-party service error',
  'API.ERROR.CODE.NEST.5001': 'HTTP request failed',
  'API.ERROR.CODE.NEST.5002': 'API call failed',

  'API.ERROR.CODE.NEST.6000': 'WhatsApp service error',
  'API.ERROR.CODE.NEST.6001': 'WhatsApp message sending failed',
  'API.ERROR.CODE.NEST.6002': 'WhatsApp Webhook error',
  'API.ERROR.CODE.NEST.6003': 'WhatsApp tracking data does not exist',
  'API.ERROR.CODE.NEST.6004': 'WhatsApp tracking parameter missing',

  'API.ERROR.CODE.NEST.7000': 'The current campaign name already exists',
  'API.ERROR.CODE.NEST.7001':
    'The current campaign does not exist or has no access',
  'API.ERROR.CODE.NEST.7002':
    'The current campaign is not a draft and cannot be modified',
  'API.ERROR.CODE.NEST.7003': 'Missing task parameter list',
  'API.ERROR.CODE.NEST.7004': 'Task parameter list format error',
  'API.ERROR.CODE.NEST.7005': 'Task creation failed',
  'API.ERROR.CODE.NEST.7006': 'Invalid sender phone number',
  'API.ERROR.CODE.NEST.7007':
    'The current campaign is not in progress and cannot be cancelled',
  'API.ERROR.CODE.NEST.7008':
    'The current campaign is not paused and cannot be resumed',
  'API.ERROR.CODE.NEST.7009': 'Send time must be greater than current time',

  'API.ERROR.CODE.NEST.8000': 'Game does not exist',

  'API.ERROR.CODE.NEST.10000': 'Failed to get template',

  'API.ERROR.CODE.NEST.ERROR': 'Request failed',
  'API.ERROR.CODE.19002': 'Contacts are being added....',
  'API.ERROR.CODE.19028':
    'Steam account currently unavailable. Please check settings.',

  'API.ERROR.CODE.70006': 'An experiment is under review. Please wait until it\'s completed before submitting a new application.',
  'API.ERROR.CODE.70007': 'Message push feature not enabled for this project',

  // 用户中心
  'API.ERROR.CODE.23001': 'Name already exists.',
  'API.ERROR.CODE.23002': `Limit reached (${ACCOUNT_CENTER_API_KEY_MAX_NUM}/${ACCOUNT_CENTER_API_KEY_MAX_NUM})`,
};
